var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[_c('q-product-library-agent-submenu'),_c('v-row',{staticClass:"mx-5",attrs:{"justify":"space-between","align":"stretch"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('q-agent-product-data-table',{attrs:{"carrier_id":_vm.carrier_id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }